import { render, staticRenderFns } from "./edit-issue.vue?vue&type=template&id=5a04c3e8&scoped=true&"
import script from "./edit-issue.vue?vue&type=script&lang=js&"
export * from "./edit-issue.vue?vue&type=script&lang=js&"
import style0 from "./edit-issue.vue?vue&type=style&index=0&id=5a04c3e8&prod&lang=scss&"
import style1 from "./edit-issue.vue?vue&type=style&index=1&id=5a04c3e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a04c3e8",
  null
  
)

export default component.exports